import { useEffect, useState } from "react";
import { Course, sendPostReq } from "../Scripts/misc";

import "../Styles/userCourses.css"
import { Modal } from "bootstrap";
import TeacherCourseCard from "../Components/TeacherCourses/TeacherCourseCard";

interface Props {
    /*userData: User | undefined,*/
    courses: Course[],
    token: string,
}

function TeacherCourses({token, courses}: Props) {

    let [selectedCourse, setSelectedCourse] = useState<Course>(courses[0])

    let successModal: Modal | undefined = undefined;

    useEffect(() => {
        successModal = new Modal(document.getElementById("successModal") as HTMLElement)
    }, [selectedCourse])

    const deleteCourse = async () => {
        
        let res = await sendPostReq("/api/deleteCourse", {token: token, course: selectedCourse.id})

        switch(res.data) {
            /*case "signedIn":
                waitlistModal?.show()
                break
            case "courseFull":
                fullModal?.show()
                break
            case "rejected":
                rejectedModal?.show()
                break*/
            default:
                successModal?.show()
                break
        }

    }

    return ( 
        <>

<div className="container-fluid-user mt-5">
    <div className="filter-block" style={{marginBottom: "0px"}}>
        <div className="d-flex justify-content-between align-items-center mb-3">
            <h3><b>Moje Kroužky</b></h3>
        </div>
    </div>

    <div className="container-fluid" style={{marginTop: "0px"}}> 
        <table className="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>Název </th>
                    <th>Čas</th>
                    <th>Detaily </th>
                </tr>
            </thead>
            <tbody>
                {courses.length ? courses.map((course) => {
                    return <TeacherCourseCard course={course} selectCourse={() => {setSelectedCourse(course)}}/>
                }) : 
                <div className="center-align" style={{width: "100vw", padding: "5vh"}}>
                    <h1>Nemáte vytvořené žádné kroužky</h1>
                </div>}
            </tbody>
        </table>
    </div>

    {/* Delete modal */}
    <div className="modal fade" id="deleteModal" tabIndex={-1} aria-labelledby="deleteLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteLabel">Přihlásit se na tento kroužek?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Jste si jistý/á, že se chcete kroužek {selectedCourse?.name} smazat?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Zrušit</button>
                            <button type="button" className="btn btn-danger" onClick={deleteCourse} data-dismiss="modal">Potvrdit</button>
                        </div>
                    </div>
                </div>
    </div>

    {/* Delete succesful modal*/}
    <div className="modal fade" id="successModal" tabIndex={-1} aria-labelledby="successLabel">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="successLabel">Přihlásit se na tento kroužek?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Kroužek {selectedCourse?.name} byl úspěšně smazán
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => {successModal?.hide();window.location.reload()}}>Ok</button>
                        </div>
                    </div>
                </div>
    </div>
</div>

        </>
     );
}

export default TeacherCourses;